<template>
  <form @submit.prevent="submit">
    <fg-input label="Name" type="text" v-model="location.name"
      :error="valErrors['name'] ? valErrors['name'][0] : null" />
    <div>
      <label>Standardtext für Lager</label>
      <div class="form-group has-label">
        <textarea class="form-control" v-model="location.warehouse_default_text" rows="3"></textarea>
      </div>
    </div>
    <button type="submit" class="btn btn-fill btn-info">{{ submitText }}</button>
  </form>
</template>

<script>
export default {
  props: ['valErrors', 'initLocation', 'submitText'],
  data() {
    return {
      location: this.initLocation
    }
  },
  methods: {
    submit() {
      this.$emit('submit', this.location)
    }
  }
}
</script>

<style></style>
